export const serverLink =
  window.location.hostname === 'localhost'
    ? 'http://localhost:8000'
    : 'https://portal.dmsi-sims.com';
